import {type FunctionalComponent, h} from '@stencil/core';
import type {SortOptionResponse} from '../../../../../models/cose-api/response/result-response.dto';
import type { labelProviderInterface } from '../../../../LabelProviderInterface';


export interface ResultsSorting {
    sortingOptions: Array<SortOptionResponse>;
    defaultValueId: string
    enableSorting: boolean
    labelProvider: labelProviderInterface
    scrollToTop?: boolean
}

export const ResultsSorting: FunctionalComponent<ResultsSorting> = (props) => {

    const {sortingOptions, defaultValueId, enableSorting, labelProvider, scrollToTop} = props;

    return (
      sortingOptions?.length > 0 && enableSorting ? <div class={'search-tab__results-sorting'}>
        <svs-sorting-dropdown
          sortOptions={sortingOptions}
          defaultValueId={defaultValueId}
          labelProvider={(e,f)=>labelProvider(e,f)}
          scrollToTop={scrollToTop}
        />
      </div> : ''
    );
};
